module.exports = __webpack_public_path__ + "static/under-construction-d660bb636ca3f590057e52247a4342d8.png";